import {CanActivateFn, Router} from '@angular/router';
import {inject, Signal} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {firstValueFrom} from 'rxjs';
import {User, UserRole} from 'patja-api';
import {RoutePaths} from '../../app.routes';

export const rolesGuard: CanActivateFn = async route => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  const allowedRoles = route.data['allowedRoles'];
  const user: Signal<User | null> = await firstValueFrom(authService.getUser());
  const hasRole = allowedRoles.some((role: UserRole) => user()?.authorities.includes(role));

  if (!hasRole) {
    await router.navigateByUrl(RoutePaths.Home);
    return false;
  }

  return true;
};
